export enum ApplicableType {
	Unknown = 0,
	Applicable = 1,
	NotInLandscape = 2,
	SensorNotWork = 3,
	Policy = 4,
}
export enum ApproachDistanceType {
	Near = 0,
	Middle = 1,
	Far = 2,
}

export enum PresenceLeaveWaitTimeType {
	Short = 0,
	Middle = 1,
	Long = 2,
}

export enum PresenceLeaveDistanceType {
	Near = 0,
	Middle = 1,
	Far = 2,
}

export enum PresenceLeaveActionType {
	Standby = 0,
	Lock = 1,
}

export enum PrivacyGuardDistanceType {
	Far = 0,
	Middle = 1,
	Short = 2,
}
export enum PrivacyGuardActionType {
	BlurAndAlert = 0,
	Alert = 1,
}
export enum FeatureCapabilityType {
	None = 0x0,
	ApproachApplicable = 0x1,
	ApproachEnabled = 0x2,
	ApproachDistanceOptions = 0x4,
	ApproachDistance = 0x8,
	ApproachDistanceAutoAdjust = 0x10,

	PresenceLeaveApplicable = 0x20,
	PresenceLeaveEnabled = 0x40,
	PresenceLeaveDistanceOptions = 0x200,
	PresenceLeaveDistance = 0x400,
	PresenceLeaveDistanceAutoAdjust = 0x800,
	PresenceLeaveWaitTimeOptions = 0x80,
	PresenceLeaveWaitTime = 0x100,
	PresenceLeaveAction = 0x1000,

	PrivacyGuardApplicable = 0x2000,
	PrivacyGuardEnabled = 0x4000,
	PrivacyGuardDistanceOptions = 0x8000,
	PrivacyGuardDistance = 0x10000,
	PrivacyGuardAction = 0x20000,

	FaceIdRegistered = 0x40000,
	HelloFaceSupported = 0x80000,
}
